// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"0246e922","769":"bbaa294a"}[chunkId] + ".chunk.js";
};